export enum PayFrequencyEnum {
  Weekly = "Weekly",
  Biweekly = "Biweekly",
  Monthly = "Monthly",
}

export const PayFrequency = [
  { value: "", label: "Select pay frequency" },
  { value: PayFrequencyEnum.Weekly, label: "Weekly" },
  { value: PayFrequencyEnum.Biweekly, label: "Biweekly" },
  { value: PayFrequencyEnum.Monthly, label: "Monthly" },
];

export const payFrequencyLabels: Record<string, string> = {
  [PayFrequencyEnum.Weekly]: "Weekly",
  [PayFrequencyEnum.Biweekly]: "Biweekly",
  [PayFrequencyEnum.Monthly]: "Monthly",
  weekly: "Weekly",
  biweekly: "Biweekly",
  monthly: "Monthly",
};
